
import React from 'react';

interface TestimonialCardProps {
  quote: string;
  author: string;
  company: string;
  role: string;
  imageSrc?: string;
}

const TestimonialCard = ({ quote, author, company, role, imageSrc }: TestimonialCardProps) => {
  return (
    <div className="bg-white p-6 rounded-lg shadow-md border border-gray-100 hover:border-l-4 hover:border-l-brand-red hover:bg-brand-lightBlue/20 transition-all h-full flex flex-col">
      <div className="flex mb-4 text-brand-red" aria-label="5 van 5 sterren" role="img">
        {[...Array(5)].map((_, i) => (
          <svg key={i} xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
            <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" />
          </svg>
        ))}
      </div>
      <blockquote className="italic text-gray-700 mb-6 flex-grow">
        <p>{quote}</p>
      </blockquote>
      <footer className="mt-auto flex items-center gap-4">
        {imageSrc && (
          <div className="relative w-14 h-14 rounded-full overflow-hidden">
            <img 
              src={imageSrc} 
              alt={`Foto van ${author}`} 
              className="w-full h-full object-cover"
              width="56"
              height="56"
            />
            <div className="absolute inset-0 bg-brand-blue opacity-20 mix-blend-multiply" aria-hidden="true"></div>
          </div>
        )}
        <div>
          <cite className="font-bold text-gray-900 not-italic">{author}</cite>
          <p className="text-sm text-gray-600">{role}, {company}</p>
        </div>
      </footer>
    </div>
  );
};

export default TestimonialCard;
